import { render, staticRenderFns } from "./InspectionDetailContent.vue?vue&type=template&id=731b28d5&scoped=true&"
import script from "./InspectionDetailContent.vue?vue&type=script&lang=js&"
export * from "./InspectionDetailContent.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDetailContent.vue?vue&type=style&index=0&id=731b28d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731b28d5",
  null
  
)

export default component.exports